import { getStorage, ref, deleteObject } from "firebase/storage";

const storage = getStorage();

export async function removeFromStorage(path) {
  return new Promise(function (resolve) {
    const storageRef = ref(storage, path);
    deleteObject(storageRef)
      .then(() => {
        // File deleted successfully
        console.log("File deleted successfully!");
        resolve(true);
      })
      .catch((error) => {
        // Uh-oh, an error occurred!
        throw new Error("Error deleting file:" + error.message);
      });
  });
}
